import { render } from "./LeadsIndex.vue?vue&type=template&id=198608b6"
import script from "./LeadsIndex.vue?vue&type=script&lang=js"
export * from "./LeadsIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__